import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ErrorModel } from '../models/error-model';
import { snackBars } from '../utils/catalog';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  constructor(
    private translator: TranslateService,
    private snackBar: MatSnackBar
  ) {}

  async handleError(e: any): Promise<void> {
    const err = e.rejection || e;

    console.error(err);

    const defaultCode = 'error.default';
    const defaultMessage = this.translator.instant(defaultCode);

    let message = defaultMessage;

    if (err instanceof HttpErrorResponse) {
      message = this.translator.instant(err.error.code || defaultCode, {
        default: defaultMessage,
      });
    } else if (err instanceof ErrorModel) {
      message = this.translator.instant(err.code || defaultCode, {
        default: defaultMessage,
      });
    }

    this.snackBar.open(message, undefined, {
      duration: snackBars.durations.default,
    });
  }
}
